<script lang="ts">
import { computed, defineComponent } from "vue";

import { useIconSize } from "@/composables/icon";

export default defineComponent({
  props: {
    scale: {
      type: Number,
      default: 1,
    },
    colorVar: {
      type: String,
      default: "--c-fg",
    },
  },
  setup(props) {
    const { iconSize: size } = useIconSize(props.scale);
    const color = computed(() => `rgb(var(${props.colorVar}) / 100%)`);
    const style = computed(() => {
      return {
        stroke: "none",
        fill: color.value,
        width: `${size.value}px`,
        height: `${size.value}px`,
      };
    });
    return {
      style,
    };
  },
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="48px"
    width="48px"
    viewBox="0 0 48 48"
    :style="style"
  >
    <path
      fill-rule="nonzero"
      d="M18.50693576,37 C17.81879998,37 17.22971405,36.7552083 16.73967796,36.265625 C16.24964188,35.7760417 16.00462384,35.1875 16.00462384,34.5 C16.00462384,33.8125 16.24964188,33.2239583 16.73967796,32.734375 C17.22971405,32.2447917 17.81879998,32 18.50693576,32 C19.19507153,32 19.78415746,32.2447917 20.27419355,32.734375 C20.76422963,33.2239583 21.0092477,33.8125 21.0092477,34.5 C21.0092477,35.1875 20.76422963,35.7760417 20.27419355,36.265625 C19.78415746,36.7552083 19.19507153,37 18.50693576,37 Z M31.0184953,37 C30.3303596,37 29.7412736,36.7552083 29.2512376,36.265625 C28.7612015,35.7760417 28.5161834,35.1875 28.5161834,34.5 C28.5161834,33.8125 28.7612015,33.2239583 29.2512376,32.734375 C29.7412736,32.2447917 30.3303596,32 31.0184953,32 C31.7066311,32 32.2957171,32.2447917 32.7857531,32.734375 C33.2757892,33.2239583 33.5208073,33.8125 33.5208073,34.5 C33.5208073,35.1875 33.2757892,35.7760417 32.7857531,36.265625 C32.2957171,36.7552083 31.7066311,37 31.0184953,37 Z M17.44345319,17 L20.44622749,23.25 L29.2043192,23.25 L32.6449981,17 L17.44345319,17 Z M16.25485503,14.5 L34.7094054,14.5 C35.1890152,14.5 35.5539357,14.7135417 35.8041669,15.140625 C36.0543981,15.5677083 36.0648244,16 35.8354458,16.4375 L31.3938421,24.4375 C31.1644635,24.8541667 30.8568877,25.1770833 30.4711146,25.40625 C30.0853415,25.6354167 29.6630764,25.75 29.2043192,25.75 L19.88320731,25.75 L18.50693576,28.25 L33.5208073,28.25 L33.5208073,30.75 L18.50693576,30.75 C17.56856879,30.75 16.85958041,30.3385417 16.37997063,29.515625 C15.90036084,28.6927083 15.87950824,27.875 16.31741283,27.0625 L18.00647337,24 L13.50231192,14.5 L11,14.5 L11,12 L15.06625687,12 L16.25485503,14.5 Z M20.44622749,23.2911932 L29.2043192,23.2911932 L20.44622749,23.2911932 Z"
    />
  </svg>
</template>
